export default "__VITE_ASSET__B87G5deG__"